import StudyForm from '../../../components/studies/StudyForm'
import StudyDetails from "../../../components/studies/StudyDetails.vue";
import StudyDefinitionForm from "../../../components/studies/StudyDefinitionForm.vue";

export default [
    {
        path: '',
        name: 'study.view',
        component: StudyDetails
    },
    {
        path: 'edit',
        name: 'study.edit',
        component: StudyForm,
        props: { mode: 'edit' }
    },
    {
        path: '/study/view/:id/definition/add',
        name: 'study.definition.add',
        component: StudyDefinitionForm
    },
    {
        path: '/study/view/:id/definition/:definition/edit',
        name: 'study.definition.edit',
        component: StudyDefinitionForm
    }
]
